import React, { useEffect, useState } from 'react';
import Section from '@components/Section';
import Container from '@components/ContentContainer';
import ViewMessage from '@components/ViewMessage';
import { LoaderIcon } from '@components/Icons';
import { apiRequest } from '@support/api';
import { useParams } from 'react-router-dom';
import { getVerifyEmailRedirect } from '@support/verify-email-redirect';
import { GenericErrorMessage } from './ErrorBoundary';

export default function EmailVerificationRedirect() {
  const [didError, setDidError] = useState(false);
  const { id } = useParams();

  async function completeVerification(signal: AbortSignal): Promise<void> {
    try {
      await apiRequest<any>('GET', `/verified-emails/${id}/verify/`, undefined, {
        apiVersion: 'v2',
      });
      if (signal.aborted) {
        return;
      }

      window.location.href = getVerifyEmailRedirect() || '/';
    } catch (e) {
      console.error(e);
      setDidError(true);
    }
  }

  useEffect(() => {
    const abortController = new AbortController();
    completeVerification(abortController.signal);
    return () => abortController.abort();
  }, []);

  const message = didError ? (
    <GenericErrorMessage />
  ) : (
    <ViewMessage
      icon={<LoaderIcon width={22} height={22} />}
      headline="Finishing Email Verification"
      message={
        <>
          We're wrapping up your email
          <br />
          verification and will redirect
          <br />
          you in a moment.
        </>
      }
    />
  );

  return (
    <Container>
      <Container.Primary id="content" header={<></>}>
        <Section>{message}</Section>
      </Container.Primary>
      <Container.Sidebar />
    </Container>
  );
}
